import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as USER_FOLLOWING_TYPE} from '../creators/user.following';

export function* createSuccess(action) {
    try {
        yield put({type: "USER_FOLLOWERS_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "USER_FOLLOWERS_DELETE", data : action.payload});
    } catch (error) {

    }
}

export function* watchFollows() {
    yield takeEvery(USER_FOLLOWING_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(USER_FOLLOWING_TYPE.DELETE_SUCCESS, deleteSuccess);
}

export default watchFollows;

